import React, { useState } from 'react';
import { anonymizeText } from '../../services/factFinderApi';

function AnonymizerPanel({ narrative }) {
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [copied, setCopied] = useState(false);

  async function handleAnonymize() {
    if (!narrative || narrative.length < 10) {
      setError('Narrative must be at least 10 characters.');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const res = await anonymizeText(narrative);
      if (res.success) {
        setResult(res);
      } else {
        setError(res.error || 'Anonymization failed.');
      }
    } catch (err) {
      setError(err.message || 'Anonymization failed.');
    } finally {
      setLoading(false);
    }
  }

  async function handleCopy() {
    if (!result?.anonymized_text) return;
    try {
      await navigator.clipboard.writeText(result.anonymized_text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Copy failed:', err);
    }
  }

  return (
    <div className="ff-card ff-p4-panel" data-testid="anonymizer-panel">
      <div className="ff-p4-header">
        <div>
          <h3>Anonymizer</h3>
          <p className="ff-card-description">
            Strip names, employee IDs, and addresses before saving or sharing.
          </p>
        </div>
        <button
          className="ff-btn-primary ff-btn-sm"
          onClick={handleAnonymize}
          disabled={loading || !narrative || narrative.length < 10}
          data-testid="anonymize-btn"
        >
          {loading ? 'Processing...' : 'Anonymize'}
        </button>
      </div>

      {error && <div className="ff-inline-error">{error}</div>}

      {result && (
        <div className="ff-p4-result" data-testid="anonymize-result">
          <div className="ff-output-card">
            <div className="ff-output-header">
              <h3>Anonymized Text</h3>
              <button
                className="ff-copy-btn"
                onClick={handleCopy}
                data-testid="copy-anonymized"
              >
                {copied ? '✓ Copied' : 'Copy'}
              </button>
            </div>
            <div className="ff-output-content">{result.anonymized_text}</div>
          </div>

          {result.replacements?.length > 0 && (
            <div className="ff-replacements" data-testid="replacements-list">
              <h4>Replacements Made</h4>
              <div className="ff-replacement-grid">
                {result.replacements.map((r, idx) => (
                  <div key={idx} className="ff-replacement-item">
                    <span className="ff-repl-original">{r.original}</span>
                    <span className="ff-repl-arrow">&rarr;</span>
                    <span className="ff-repl-new">{r.replaced_with}</span>
                    <span className="ff-repl-type">{r.type}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default AnonymizerPanel;
